import axios from '@/lib/axios';
import { PurchaseOrderOutline } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2640. 以前のプロジェクト（売上）登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/prev_purchase_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  prev_purchase_order_id: number;
};
const createPrevPurchaseOrder = (props: Props): Promise<PurchaseOrderOutline> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/prev_purchase_orders`,
    props
  );
};

export const useCreatePrevPurchaseOrder = () => {
  return useMutation({
    mutationFn: createPrevPurchaseOrder,
  });
};
